export const user = {
  "USER1001": {
    "title": "Usuário Repetido",
    "message": "A pergunta inserida já existe em nosso banco de dados"
  }
}
